import { Text } from '@axo/ui-core/components/typography';
import { USPsList } from '@axo/ui-feature/components/USPsList';
import { ReactNode } from 'react';
import styles from './AuthenticationCard.module.scss';

type TAuthenticationCardProps = {
  title: string;
  description: string;
  bullets?: string[];
  extra?: ReactNode;
  children: ReactNode;
};

export const AuthenticationCard = ({
  title,
  description,
  bullets,
  extra,
  children,
}: TAuthenticationCardProps) => {
  return (
    <div className={styles.authenticationCard}>
      <Text as={'h3'}>
        <b>{title}</b>
      </Text>
      <Text as={'p'} dangerouslySetInnerHTML={{ __html: description }} />
      <USPsList gap={'3xs'}>
        {bullets?.map((bullet) => (
          <USPsList.Item key={bullet}>
            <span dangerouslySetInnerHTML={{ __html: bullet }} />
          </USPsList.Item>
        ))}
      </USPsList>

      {extra && <Text as={'p'}>{extra}</Text>}

      <div className={styles.authentication}>{children}</div>
    </div>
  );
};
